export const SuccessFiledIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#333333" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6832 13.9813L15.5937 8.66162C15.7565 8.48518 16.0316 8.47418 16.2081 8.63705C16.3845 8.79992 16.3955 9.07499 16.2326 9.25143L11.0152 14.9036C10.8477 15.0851 10.5629 15.0908 10.3883 14.9161L8.6492 13.177C8.4794 13.0072 8.4794 12.7319 8.6492 12.5621C8.81899 12.3923 9.09428 12.3923 9.26407 12.5621L10.6832 13.9813Z"
      fill="white"
    />
  </svg>
);
